export default __webpack_public_path__ + "static/media/headshot.1e18d30d.png";